// extracted by mini-css-extract-plugin
export default {"checkout_container":"OrderSummary_checkout_container__H1cAq","product":"OrderSummary_product__pAUyh","price":"OrderSummary_price__rQCXD","total":"OrderSummary_total__PDS2A"};